import {Service, service, inject} from "./di";
import {AuthenticationService} from "./AuthenticationService";
import {AuthStatus} from "../services/definitions/IAuthenticationService";
import {LinkService} from "./LinkService";
import {EventService} from "./EventService";



@service("DataFormSevice")
export class DataFormService extends Service {
	@inject auth: AuthenticationService;
	@inject eventService: EventService;

	redirectToForm ()  {
		const linkService = LinkService.getInstance();
		linkService.execute("/data", window);
	}

	handleFormClicked = () => {
		if (this.auth.status === AuthStatus.LOGGED_IN) {
			this.redirectToForm();
		} else {
			this.eventService.showModalInForm();
			window.addEventListener("redirect-to-form", this.redirectToForm);
		}
	}

	unsubscribeFromRedirect = () => {
		window.removeEventListener("redirect-to-form", this.redirectToForm);
	}
}
